import React, { useEffect } from 'react';
import loadingIcon from '../../../../assets/svg/loading-sync.svg';
import failIcon from '../../../../assets/svg/fail-sync-small.svg';
import successIcon from '../../../../assets/svg/sucess-sync.svg';
import finishIcon from '../../../../assets/svg/finished-sync.svg';
import { StepStatus } from '../../../../model';
import { Button } from 'antd';

interface IStep {
  readonly title: string;
  readonly description: {
    readonly text1?: string;
    readonly text2?: string;
    readonly textSuccess?: string;
    readonly textFail?: string;
    readonly buttonText?: string;
    readonly onButtonClick?: () => void;
    readonly buttonSuccessText?: string;
    readonly buttonFailText?: string;
    readonly onButtonSuccessClick?: () => void;
    readonly onButtonFailClick?: () => void;
  };
  status: StepStatus;
}

interface IProps {
  steps: IStep[];
  current?: number;
}

export const GameSyncStep = (props: IProps) => {
  const { steps, current } = props;
  useEffect(() => {
    // steps
  }, [steps, current]);
  return (
    <div className="sync-steps">
      {steps.map((step, index) => (
        <div key={index} className="sync-step">
          <div className="step-top">
            {step.status === StepStatus.Progress ? (
              <div
                className="step-dot"
                style={{
                  backgroundColor: index === current ? '#5764F1' : '#FFFFFF',
                }}
              >
                {step.status === StepStatus.Progress && (
                  <span
                    className="step-number"
                    style={{ color: index === current ? '#FFFFFF' : '#86909C' }}
                  >
                    {index + 1}
                  </span>
                )}
              </div>
            ) : (
              <div className="step-no-border">
                {step.status === StepStatus.Finished && (
                  <img src={finishIcon} alt="finish" />
                )}
                {step.status === StepStatus.Waiting && (
                  <img
                    src={loadingIcon}
                    alt="Waiting"
                    className="waiting-icon"
                  />
                )}
                {step.status === StepStatus.Success && (
                  <img src={successIcon} alt="Success" />
                )}
                {step.status === StepStatus.Fail && (
                  <img src={failIcon} alt="Fail" />
                )}
              </div>
            )}
            <div
              className="sync-step-title"
              style={{ color: index === current ? '#1D2129' : '#4E5969' }}
            >
              {step.title}
            </div>
          </div>
          <div className="step-content">
            <div className="flex-container">
              {index < steps.length - 1 && (
                <div
                  className={`arrow-jiantou ${
                    current !== undefined && index <= current - 1
                      ? 'highlighted'
                      : ''
                  }`}
                ></div>
              )}
              {index === current && (
                <div className="sync-description">
                  {step.status === StepStatus.Success &&
                    step.description.textSuccess && (
                      <div className="sync-success">
                        <div className="sync-textSuccess-text">
                          {step.description.textSuccess}
                        </div>
                        <Button
                          className="gc-btn gc-btn-primary btn-result"
                          onClick={step.description.onButtonSuccessClick}
                        >
                          {step.description.buttonSuccessText}
                        </Button>
                      </div>
                    )}
                  {step.status === StepStatus.Fail &&
                    step.description.textFail && (
                      <div className="sync-fail">
                        <div className="sync-textFail-text">
                          {step.description.textFail}
                        </div>
                        <Button
                          className="gc-btn gc-btn-primary btn-result"
                          onClick={step.description.onButtonFailClick}
                        >
                          {step.description.buttonFailText}
                        </Button>
                      </div>
                    )}
                  {step.status !== StepStatus.Success &&
                    step.status !== StepStatus.Fail && (
                      <>
                        {step.description.text1 && (
                          <div className="sync-text1">
                            {step.description.text1}
                          </div>
                        )}
                        {step.description.text2 && (
                          <div className="sync-text2">
                            {step.description.text2}
                          </div>
                        )}
                      </>
                    )}
                  {step.status !== StepStatus.Finished &&
                    step.description.buttonText && (
                      <Button
                        className="gc-btn gc-btn-primary btn-result"
                        onClick={step.description.onButtonClick}
                      >
                        {step.description.buttonText}
                      </Button>
                    )}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
